import { ROUTES } from "../constants";

const TITLE_DEFAULT = "Dash AI | Free No-Code ML Dashboard";
const DESCRIPTION_DEFAULT =
	"Predictive Analytics made easy! Dash AI is a 100% free no-code machine learning platform which makes advanced ML easy to use for everyone. Forecast revenue, detect fraud, build financial models and more with only a few clicks.";

const titles = { "/": TITLE_DEFAULT };
const descriptions = { "/": DESCRIPTION_DEFAULT };

titles[ROUTES.data_ingestion] = "Dash AI | ML Dashboard";
descriptions[ROUTES.data_ingestion] =
	"Build machine learning models with Dash AI using our free no-code ML dashboard. Train neural networks, apply sentiment analysis and more!";

titles[ROUTES.batch_prediction] = "Dash AI | ML Batch Prediction";
descriptions[ROUTES.batch_prediction] =
	"Make predictions using your trained ML models on large datasets.";

titles[ROUTES.variable_correlation] = "Dash AI | Variable Correlations";
descriptions[ROUTES.variable_correlation] =
	"Determine how your variables are correlated with each other.";

titles[ROUTES.data_cleaning] = "Dash AI | Data Cleaning";
descriptions[ROUTES.data_cleaning] =
	"Clean your dataset to make it ready for Machine Learning.";

titles[ROUTES.nlp] = "Dash AI | Topic Modeling";
descriptions[ROUTES.nlp] = "Topic modeling of natural language text data.";

titles[ROUTES.sentiment] = "Dash AI | Sentiment Analysis";
descriptions[ROUTES.sentiment] = "Analyze sentiment of natural language text.";

titles[ROUTES.model_training] = "Dash AI | Model Training";
descriptions[ROUTES.model_training] =
	"Train ML models from Logistic Regression to Neural Networks.";

titles[ROUTES.var_importance] = "Dash AI | Variable Importance";
descriptions[ROUTES.var_importance] =
	"Analyze how important each variable is to predicting your target variable.";

titles[ROUTES.persona_prediction] = "Dash AI | Persona Prediction";
descriptions[ROUTES.persona_prediction] =
	"Make predictions using trained ML models on multiple personas.";

titles[ROUTES.batch_prediction] = "Dash AI | Batch Prediction";
descriptions[ROUTES.batch_prediction] =
	"Make predictions using trained ML models on larger datasets.";

export function setMetaTags() {
	var loc = window.location.pathname;
	console.log(loc);
	var title = titles[loc] || TITLE_DEFAULT;
	var description = descriptions[loc] || DESCRIPTION_DEFAULT;

	setTitle(title);
	setDescription(description);
	if (
		loc !== "/" &&
		loc !== ROUTES.data_ingestion &&
		loc != ROUTES.legal &&
		loc != ROUTES.privacy
	) {
		setCanonical();
	}
	if (loc == ROUTES.privacy || loc == ROUTES.legal) {
		setNoIndex();
	}
}

function setTitle(title: string) {
	console.log("Title");
	console.log(title);
	document.title = title;
}

function setDescription(description: string) {
	console.log("Desc");
	console.log(description);
	const existingMetaDesc = document.querySelector('meta[name="description"]');
	if (existingMetaDesc) {
		existingMetaDesc.remove();
	}

	const metaDesc = document.createElement("meta");
	metaDesc.name = "description";
	metaDesc.content = description;
	document.head.appendChild(metaDesc);
}

function setCanonical() {
	console.log("Canonical");
	const canonicalUrl = "https://dash-ai.app/dashboard/dataUpload";

	const existingCanonical = document.querySelector('link[rel="canonical"]');
	if (existingCanonical) {
		existingCanonical.remove();
	}

	const canonicalLink = document.createElement("link");
	canonicalLink.rel = "canonical";
	canonicalLink.href = canonicalUrl;
	document.head.appendChild(canonicalLink);
}

function setNoIndex() {
	console.log("No Index");
	const existingNoIndex = document.querySelector('meta[name="robots"]');
	if (existingNoIndex) {
		existingNoIndex.remove();
	}

	const metaRobots = document.createElement("meta");
	metaRobots.name = "robots";
	metaRobots.content = "noindex";
	document.head.appendChild(metaRobots);
}
